// https://docs.mapbox.com/api/maps/styles/

export const basemapStyles = {
  // mapbox basemaps
  Streets: {
    label: "Streets",
    src: "mapbox://styles/ckeating/cm73r3w2d013b01s1bi5jbvcd",
    type: "mapbox",
  },
  Outdoors: {
    label: "Outdoors",
    src: "mapbox://styles/ckeating/cm73tminq001p01s3evkz36cv",
    type: "mapbox",
  },
  Light: {
    label: "Light",
    src: "mapbox://styles/ckeating/cm73t2vjw001e01s3bwdb8whc",
    type: "mapbox",
  },
  Dark: {
    label: "Dark",
    src: "mapbox://styles/ckeating/cm73t6l23001i01s31f355yod",
    type: "mapbox",
  },
  // Satellite: {
  //   label: "Satellite",
  //   src: "mapbox://styles/mapbox/satellite-v9",
  //   type: "mapbox",
  // },
  "Satellite Streets": {
    label: "Satellite Streets",
    src: "mapbox://styles/ckeating/cm73t9bvb00ch01qu9vfk09c5",
    type: "mapbox",
  },

  // USGS basemaps
  "USGS Topo": {
    label: "USGS Topo",
    src: "https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}?blankTile=false",
    type: "tileLayer",
    minZoom: 0,
    maxZoom: 15,
    tileSize: 256,
  },
  "USA Topo Maps": {
    label: "USA Topo Maps",
    src: "https://server.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}",
    type: "tileLayer",
    minZoom: 0,
    maxZoom: 15,
    tileSize: 256,
  },
  // {label: "Navigation Day", src: "mapbox://styles/mapbox/navigation-day-v1"},
  // {label: "Navigation Night", src: "mapbox://styles/mapbox/navigation-night-v1"},
};
